import React from 'react'
import { NextPage } from 'next'
import LessonContent from 'src/components/Curso/Classroom'
import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import { getLessonRequest } from 'src/store/lessons'
import { State } from 'src/store/rootReducers'

const Classroom: NextPage = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const params = router.query as { classroom: string }
  const module = useSelector((state: State) => state.course.module)

  React.useEffect(() => {
    if (params.classroom) {
      ;(async () => {
        await fetchModule(params.classroom)
      })()
    }
  }, [params.classroom, router.isReady])

  async function fetchModule(slug: string) {
    dispatch(getLessonRequest(slug))
  }

  return <>{module && <LessonContent module={module} />}</>
}

export default Classroom
